import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
  }

  /* Added to Fix Footer to bottom of viewport */
  html, body {
    height: 100%;
  }
  .siteRoot {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .siteContent {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;

    &.leftAlign {

      div {
        text-align: left;
      }
    }
  }
  footer {
    width: 100%;
  }

  /* Only enable outline if user is tabbing */
  body:not(.user-is-tabbing) button:focus,
  body:not(.user-is-tabbing) input:focus,
  body:not(.user-is-tabbing) select:focus,
  body:not(.user-is-tabbing) textarea:focus {
    outline: none;
  }

  body:not(.user-is-tabbing) .accordion__title {
    &:focus {
      outline: none;
    }
  }

  /* End Fix to Place Footer on Bottom of Viewport */

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  @media screen and (min-width: 35em) {
    html {
      margin-right: calc(-100vw + 100%);
      overflow-x: hidden;
    }
  }

  @media screen and (min-width: 60em) {
    margin-bottom: 12rem;
  }

  ol, ul, li {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote::before, blockquote::after,
  q::before, q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* A. More sensible default box sizing.
  Resource: css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice */

  /* 1. This sets 1rem = 10px.
    Resource: http://snook.ca/archives/html_and_css/font-size-with-rem */

  html {
      box-sizing: border-box;
      /* [A] */
      text-size-adjust: 100%;
      font-size: 62.5%;
      /* [1] */
  }

  *,
  *::before,
  *::after {
      box-sizing: inherit;
      /* [A] */
  }

  body {
    background: #f3f3f3;
    -webkit-font-smoothing: antialiased;
    /* [1] */
    -moz-osx-font-smoothing: grayscale;
    /* [1] */
    line-height: 1.65;
    font-variant-ligatures: none;
    text-rendering: optimizeLegibility;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
    font-weight: 400;
    font-family: "Myriad Pro","A+mfCv-AXIS Font ベーシック L ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }

  button,
  input {
    font-family: inherit;
    font-size: inherit;
    background: none;
    border: none;
    outline: none;
    appearance: none;
    border-radius: 0;
    resize: none;
    &:focus {
      outline: none;
    }
    &:invalid {
      box-shadow: none;
    }
  }

  h2 {
    font-size: 3.4rem;
    letter-spacing: 0.4rem;
    margin-bottom: 3.2rem;
    font-family: "Myriad Pro", "A+mfCv-AXIS Font ベーシック EL ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;

    @media screen and (min-width: 1040px) {
      font-size: 6.4rem;
      margin-bottom: 6.4rem;
    }
  }

  h3 {
    font-size: 2.8rem;
    font-weight: 200;
    margin-bottom: 2.4rem;
    font-family: "Myriad Pro", "A+mfCv-AXIS Font ベーシック EL ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;

    @media screen and (min-width: 1040px) {
      font-size: 4rem;
      margin-bottom: 3.2rem;
    }
  }

  h4 {
    font-size: 2.4rem;
    font-weight: 300;
    margin-bottom: 2.4rem;
    font-family: "Myriad Pro", "A+mfCv-AXIS Font ベーシック L ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;

    @media screen and (min-width: 1040px) {
      font-size: 3.6rem;
      margin-bottom: 3.2rem;
    }
  }

  h5 {
    font-size: 2rem;
    line-height: 1.5;
    margin-bottom: 1.6rem;
    font-family: "Myriad Pro", "A+mfCv-AXIS Font ベーシック L ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;

    @media screen and (min-width: 1040px) {
      font-size: 2.4rem;
      margin-bottom: 2.4rem;
    }
  }

  h6 {
    font-size: 1.6rem;
    font-family: "Myriad Pro", "A+mfCv-AXIS Font ベーシック L ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;

    @media screen and (min-width: 1040px) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.6rem;
    line-height: 1.75;
    font-weight: 300;
  }

  a {
    position: relative;
    text-decoration: none;
  }

  b,
  strong {
    font-family: "Myriad Pro", "A+mfCv-AXIS Font ベーシック M ProN", "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", Arial, メイリオ, Meiryo, sans-serif;
  }

  a:hover:after,
  a:hover:before {
    width: 100%;
    left: 0;
  }

  a::after,
  a::before {
    content: '';
    position: absolute;
    top: calc(100% + 3px);
    width: 0;
    right: 0;
    height: 1px;
  }

  a:before {
    transition: width 0.2s cubic-bezier(0.57, 0.15, 0.13, 0.97) 0.1s;
    background: #ffffff;
  }

  a:after {
    transition: width 0.2s cubic-bezier(0.57, 0.15, 0.13, 0.97);
    background: #1d3d87;
  }

  .main-content {
    padding-top: 7rem;

    @media screen and (min-width: 800px) {
      padding-top: 10rem;
    }

    > section {
      &:last-child {
        margin-bottom: 8rem;
      }

      @media screen and (min-width: 1040px) {
        &:last-child {
          margin-bottom: 12rem;
        }
      }
    }
  }

  .relatedArticlesContainer {
    width: 100%;
    margin-bottom: 8rem;

    @media screen and (min-width: 1040px) {
      margin-bottom: 12rem;
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
  }
`
export default GlobalStyle
